import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { BASE_URL } from '../constants/urls';

export const useGoogleLogin = () => {
  const { auth } = useAuth();

  const login = useCallback(() => {
    // salva a URL completa (path + query + hash)
    sessionStorage.setItem('google-login-redirect', window.location.href);

    // redireciona para o backend iniciar o OAuth
    window.location.href = `${BASE_URL}/auth/google`;
  }, []);

  const handleCallback = useCallback((token) => {
    localStorage.setItem('token', token);
    auth(); // atualiza estado do AuthContext

    // pega a URL de origem completa
    const redirectUrl = sessionStorage.getItem('google-login-redirect') || '/';
    sessionStorage.removeItem('google-login-redirect');

    // redireciona para a URL original
    window.location.href = redirectUrl;
  }, [auth]);

  return { login, handleCallback };
};